import {
    MSAL_ALL_SCOPES,
    MSAL_AUTHORITY_SIGNIN,
    MSAL_AUTHORITY_SIGNUP,
    MSAL_POLICY_SIGNIN,
    MSAL_POLICY_SIGNUP,
    msalInstance,
} from "./msalConfig";
import { useAuthStore } from "@store/AuthStore";
import {pickBestAccount} from "@msal/msalUtils";

export function getPolicyFromClaims(claims: any): string | null {
    return claims?.tfp || claims?.acr || null;
}

export function authorityForPolicy(policy: string | null) {
    if (!policy) return MSAL_AUTHORITY_SIGNIN;

    const p = policy.toUpperCase();
    if (p.includes(MSAL_POLICY_SIGNUP.toUpperCase())) return MSAL_AUTHORITY_SIGNUP;
    if (p.includes(MSAL_POLICY_SIGNIN.toUpperCase())) return MSAL_AUTHORITY_SIGNIN;

    return MSAL_AUTHORITY_SIGNIN;
}

export async function getValidAccessToken(forceRefresh = false): Promise<string | null> {
    const state = useAuthStore.getState();

    if (state.accessToken && !forceRefresh) {
        console.log("[MSAL][getValidAccessToken] using token from memory");
        return state.accessToken;
    }

    const account = msalInstance.getActiveAccount() ?? pickBestAccount();
    if (!account) {
        console.log("[MSAL][getValidAccessToken] no account");
        return null;
    }

    const claims = (account.idTokenClaims as any) ?? null;
    const policy = getPolicyFromClaims(claims);
    const authority = authorityForPolicy(policy);

    try {
        console.log("[MSAL][getValidAccessToken] acquireTokenSilent", {
            homeAccountId: account.homeAccountId,
            authority,
            forceRefresh,
        });

        const res = await msalInstance.acquireTokenSilent({
            account,
            scopes: MSAL_ALL_SCOPES,
            authority,
            forceRefresh,
        });

        useAuthStore.getState().setAuth({
            isAuthenticated: true,
            account,
            accessToken: res.accessToken ?? null,
            ...(res.idTokenClaims ? { idTokenClaims: res.idTokenClaims as any } : {}),
        });

        console.log("[MSAL][getValidAccessToken] ok");
        return res.accessToken ?? null;
    } catch (e) {
        console.log("[MSAL][getValidAccessToken] failed", e);
        return null;
    }
}
